<template>
    <div>
        <HeaderSection icon="fas fa-inbox" title="Bandeja de Solicitudes">
            <template slot="buttons">
                <el-button-group>
                    <el-button
                        size="mini"
                        type="primary"
                        icon="fas fa-plus"
                        :disabled="!inbox.cat_category_id"
                        @click="makeRegister">
                        Registrar Solicitud / Generar Folio
                    </el-button>
                    <!--<el-button size="mini"
                               plain
                               @click="goToUnify"
                               icon="fas fa-folder-open"
                               type="warning">
                        Unificar expedientes
                    </el-button>-->
                    <el-button
                        size="mini"
                        type="danger"
                        icon="el-icon-arrow-left"
                        @click="goToBack">
                        Regresar
                    </el-button>
                </el-button-group>
            </template>
        </HeaderSection>
        <br>
        <el-alert
            title="Seleccione Un tipo de trámite y al menos un trámite para mostrar solicitudes"
            type="info"
            effect="dark">
        </el-alert>
        <el-form :model="inbox" ref="inbox" label-width="100px" label-position="top">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="Tipo de trámite" prop="cat_category_id"
                                  :rules="{ required: true, message: 'El campo es requerido', trigger: 'change' }">

                        <el-select v-model="inbox.cat_category_id"
                                   filterable
                                   @change="inbox.cat_procedure_id = []; inboxForm.inbox = []"
                                   v-loading="loading"
                                   element-loading-text=""
                                   element-loading-spinner="el-icon-loading"
                                   value-key="id"
                                   style="width:100%;" placeholder="Seleccionar">
                            <el-option
                                v-for="item in catalogsFilter(11)"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="Trámite" prop="cat_procedure_id"
                                  :rules="{ required: true, message: 'El campo es requerido', trigger: 'change' }">
                        <el-select v-model="inbox.cat_procedure_id"
                                   @change="getMyRequests(inbox.cat_procedure_id)"
                                   filterable
                                   v-loading="loading"
                                   element-loading-text=""
                                   element-loading-spinner="el-icon-loading"
                                   multiple
                                   style="width:100%;" placeholder="Seleccionar">
                            <el-option
                                v-for="item in catalogsFilter(5).filter(up => up.cat_category_id == inbox.cat_category_id)"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <br>
            <el-row>
                <el-col align="end">
                    <el-button type="primary" @click="getMyRequests">
                        Buscar
                    </el-button>
                </el-col>
            </el-row>
        </el-form>
        <br>
        <vue-content-loading :width="300" :height="200" v-if="loading">
            <rect x="5" y="10" rx="4" ry="4" width="200" height="15"/>
            <rect x="5" y="30" rx="4" ry="4" width="120" height="10"/>
            <rect x="5" y="50" rx="4" ry="4" width="100" height="15"/>
            <rect x="5" y="70" rx="4" ry="4" width="90" height="10"/>
        </vue-content-loading>
        <Filters v-if="showFilters"
                 :inbox="inbox"
                 :alias_this="alias_this"
                 :procedures="catalogs.filter(up => up.id == 5)[0].options"
                 :search="getMyRequests"/>
        <br>
        <el-alert
            v-if="inboxForm.inbox.length == 0"
            title="No hay solicitudes registradas para los filtros seleccionados"
            type="warning"
            effect="dark">
        </el-alert>
        <br>
        <span v-if="inboxForm.inbox && inboxForm.inbox.length > 0 && !loading">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[5,10, 15, 30]"
                :page-size="perPage"
                layout="total, ->, prev, pager, next, sizes"
                :total="total">
            </el-pagination>
            <br>
            <!--<draggable :list="inboxForm.inbox" class="dragArea list-group" v-bind="dragOptions">-->
                <el-row :gutter="20" v-for="(item, key) in inboxForm.inbox" :key="key"
                        style="padding: 0 0 10px !important">
                        <el-col :span="24">
                            <transition-group type="transition" :name="!drag ? 'flip-list' : null" :key="key +1">
                                <el-card shadow="hover" style="border: 1px solid #0C231E !important;" :key="key +1">
                                    <div slot="header">
                                        <el-row :gutter="5">
                                            <el-col :span="4">
                                                <label
                                                    style="font-size: 9pt !important; text-align: justify !important">
                                                    Folio: <span style="font-weight: bold !important; "> {{item && item.folio ? item.folio : ''}}</span>
                                                </label>
                                            </el-col>
                                            <el-col :span="8">
                                                <label
                                                    style="font-size: 9pt !important; text-align: justify !important">
                                                    Trámite: <span style="font-weight: bold !important; ">  {{item && item.procedure && item.procedure.name ? item.procedure.name : ''}}</span>
                                                </label>
                                            </el-col>
                                            <el-col :span="6">
                                                <label
                                                    style="font-size: 9pt !important; text-align: justify !important">
                                                    Estatus: <span style="font-weight: bold !important; ">  {{item && item.status && item.status.name ? item.status.name : ''}}</span>
                                                </label>
                                            </el-col>
                                            <el-col :span="6">
                                                <label
                                                    style="font-size: 9pt !important; text-align: justify !important">
                                                    Creado por: <span style="font-weight: bold !important; ">  {{item && item.user_created && item.user_created.full_name ?  item.user_created.full_name : ''}}</span>
                                                </label>
                                            </el-col>
                                        </el-row>
                                        <br>
                                        <el-row :gutter="20">
                                            <el-col :span="24" align="end">
                                                <el-button type="success" plain @click="manageRequest(item, key)"
                                                           icon="fas fa-edit"
                                                           v-if="!item.isPublic">
                                                    {{item.cat_status_id == 26 ? 'Continuar Registro' : 'Dictaminar/Actualizar'}}
                                                </el-button>
                                                 <el-button type="primary" icon="far fa-eye"
                                                            plain @click="getDocs(item.id, item.folio, item.documents)">
                                                    Ver Documentos Generados
                                                </el-button>
                                                <el-button icon="fas fa-folder-open"
                                                           type="info"
                                                           plain
                                                           @click="showUnify(item.unify)"
                                                           v-if="item.unify && item.unify.length > 0">
                                                    Explorar otras solicitudes
                                                </el-button>
                                               <el-button @click="getRequestDocs(item)"
                                                          v-if="item.documents"
                                                          icon="fas fa-archive"
                                                          plain
                                                          type="warning">Documentos Adjuntados
                                                    </el-button>
                                            </el-col>
                                        </el-row>
                                    </div>
                                    <el-collapse accordion v-model="activeName">
                                        <el-collapse-item :name="key">
                                            <template slot="title">
                                                <el-button type="text" icon="el-icon-circle-plus-outline">
                                                    Detalles:
                                                </el-button>
                                            </template>
                                            <el-row :gutter="20"
                                                    style="margin-left: -4px;margin-right: -4px;">
                                                <el-col
                                                    :span="item2.data_info && item2.data_info.form_field_type_id && item2.data_info.form_field_type_id == 9 ? 24 : 12"
                                                    v-if="item2.data_info.isActive"
                                                    v-for="(item2, key2) in item.data_form" :key="key2">

                                                    <div v-if="item2.data_info.form_field_type_id == 9">
                                                        <h2>{{item2.textData}}</h2>
                                                        <hr class="red">
                                                    </div>

                                                    <el-row :gutter="5"
                                                            v-if="item2.data_info.form_field_type_id != 9"
                                                            style="border: 0.8px solid black; padding: 11px">
                                                        <el-col :span="12">
                                                            <label
                                                                v-if="item2.data_info.form_field_type_id != 9"
                                                                class="el-form-item__label"
                                                                style="font-size: 10pt !important;">
                                                                {{item2.data_info.label}}:
                                                            </label>
                                                        </el-col>
                                                        <el-col :span="12">
                                                            <p
                                                                class="el-form-item__label"
                                                                style="font-weight: bold !important; font-size: 10pt !important; text-align: center !important">
                                                                {{filterData(item2)}}
                                                            </p>
                                                        </el-col>
                                                    </el-row>
                                                    <br>
                                                </el-col>
                                                <br>
                                            </el-row>
                                        </el-collapse-item>
                                    </el-collapse>
                                 </el-card>
                            </transition-group>
                        </el-col>
                    <!--   </draggable>-->
                    <br>
                </el-row>
                <br>
            <!--</draggable>-->
        </span>
        <span v-if="showLogs">
            <el-dialog :title="'Historial de documentos ' + customFolio"
                       :visible.sync="showLogs"
                       @close="manageTemplates.html = null; manageTemplates.isGenerate = false"
                       :close-on-press-escape="true"
                       :close-on-click-modal="true">
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-table :data="logs" border stripe>
                            <el-table-column label="Documento" prop="name"/>
                            <el-table-column label="Descargado por" prop="printed_by"/>
                            <el-table-column label="Se ha impreso (veces)" prop="count"/>
                            <el-table-column label="Firmado" prop="count">
                                <template slot-scope="props">
                                    {{props.row.isSigned ? 'Firmado' : 'Pendiente de firma'}}
                                </template>
                            </el-table-column>
                            <el-table-column label="Acciones">
                                <template slot-scope="props">
                                    <el-button type="text"
                                               @click="showDocument(
                                                   props.row.templateHtml,
                                                   props.row.cat_config_template_section_id,
                                                   props.row.count,
                                                   props.row.sipac_file_id)">
                                        ver
                                    </el-button>
                                    <el-button type="text"
                                               :disabled="props.row.isSigned && (userInfo.username != 'jsoriano'
                                               && userInfo.username != 'mmiranda')"
                                               @click="deleteDocument(props.row.id)">
                                        eliminar
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
                <span slot="footer" class="dialog-footer">
                        <el-button
                            type="danger"
                            plain
                            icon="fas fa-times"
                            @click="showLogs = false">
                            Cerrar
                        </el-button>

                    </span>
            </el-dialog>
        </span>
        <span v-if="manageModal">
            <el-dialog title="Dictaminando"
                       :visible.sync="manageModal"
                       fullscreen
                       @close="getMyRequests()"
                       :close-on-press-escape="true"
                       :close-on-click-modal="true">
                <div v-if="manageForm.data_form && manageForm.data_form.length > 0">
                    <el-form ref="manageForm" :model="manageForm">
                        <el-row>
                            <el-col>
                                 <el-form-item label="No. de Folio"
                                               :rules="[{ required: true,
                                              message: 'El campo es requerido', trigger: 'change' },
                                              { max: 100, message: 'Ingrese un máximo de ' +
                                              100 +' caracteres',trigger: ['blur','change'] }]"
                                               prop="folio">
                                    <el-input :maxlength="100"
                                              v-model="manageForm.folio"/>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="item.data_info.form_field_type_id != 14 ? 12 : 24"
                                    v-for="(item, key) in manageForm.data_form"
                                    v-if="item.data_info.isActive"
                                    :key="key">
                                <el-form-item :label="item.data_info.label"
                                              v-if="item.data_info.form_field_type_id == 1
                                              || item.data_info.form_field_type_id == 2 "
                                              :rules="[{ required: item.data_info.required
                                              && !customDisabled(item.data_info.id),
                                              message: 'El campo es requerido', trigger: 'change' },
                                              { max: item.data_info.maxLength, message: 'Ingrese un máximo de ' +
                                              item.data_info.maxLength +' caracteres',trigger: ['blur','change'] }]"
                                              :prop="'data_form.'+key+'.textData'">
                                    <el-input :maxlength="item.data_info.maxLength"
                                              :disabled="item.disabled"
                                              @change="checkIsSearchable(item)"
                                              v-if="item.data_info.form_field_type_id == 1"
                                              v-model="item.textData"/>

                                    <el-input :maxlength="item.data_info.maxLength"
                                              show-word-limit
                                              style="word-break: break-word !important; word-wrap: break-word !important; font-size: 8pt !important;"
                                              @change="checkIsSearchable(item)"
                                              type="textarea"
                                              :rows="8"
                                              resize="none"
                                              v-if="item.data_info.form_field_type_id == 2"
                                              v-model="item.textData"/>
                                </el-form-item>
                                <el-form-item :label="item.data_info.label"
                                              v-if="item.data_info.form_field_type_id == 5"
                                              :rules="[{ required: item.data_info.required,
                                              message: 'El campo es requerido', trigger: 'change' }]"
                                              :prop="'data_form.'+key+'.option_system_catalog_id'">
                                    <el-select
                                        filterable
                                        clearable
                                        :disabled="item.disabled"
                                        @change="checkIsSearchable(item); setDocument()"
                                        v-model="item.option_system_catalog_id"
                                        style="width: 100%"
                                        placeholder="Seleccionar">
                                        <el-option
                                            v-for="item2 in catalogsFilter(item.system_catalog_id, item.data_info.system_catalog_id)"
                                            :key="item2.id"
                                            :label="item.system_catalog_id != 14 ? item2.name : item2.full_name"
                                            :value="item2.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="item.data_info.label"
                                              v-if="item.data_info.form_field_type_id == 6 || item.data_info.form_field_type_id == 15"
                                              :rules="[{ required: item.data_info.required, message: 'El campo es requerido', trigger: 'change' }]"
                                              :prop="'data_form.'+key+'.dateData'">
                                    <el-date-picker
                                        :picker-options="pickerOptions"
                                        :editable="false"
                                        v-model="item.dateData"
                                        type="date"
                                        placeholder="Selecciona una fecha"
                                        style="width: 100%"
                                        format="dd/MM/yyyy"
                                        value-format="yyyy-MM-dd">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item :label="item.data_info.label"
                                              v-if="item.data_info.form_field_type_id == 10"
                                              :rules="[{ required: item.data_info.required, message: 'El campo es requerido', trigger: 'change' }]"
                                              :prop="'data_form.'+key+'.dataNumber'">
                                    <br>
                                   <el-input-number v-model="item.dataNumber"
                                                    :min="item.data_info.minLength"
                                                    :max="item.data_info.maxLength"></el-input-number>
                                </el-form-item>
                                 <el-form-item :label="item.data_info.label"
                                               v-if="item.data_info.form_field_type_id == 14 && manageForm.cat_status_id != 3"
                                               :rules="[{ required: false, message: 'El campo es requerido', trigger: 'change' }]"
                                               :prop="'data_form.'+key+'.option_system_catalog_id'">
                                     <br>

                                     <PaymentValidation :folio="manageForm.folio"
                                                        :model="customKey"
                                                        :isAdmin="true"
                                                        :procedure="manageForm.cat_procedure_id">
                                     </PaymentValidation>

                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                               <el-form-item label="Estatus"
                                             prop="cat_status_id"
                                             :rules="[{ required: true, message: 'El campo es requerido', trigger: 'change' }]">
                                    <el-select
                                        filterable
                                        v-model="manageForm.cat_status_id"
                                        style="width: 100%"
                                        placeholder="Seleccionar">
                                        <el-option
                                            v-for="item2 in catalogsFilter(12)"
                                            :key="item2.id"
                                            :label="item2.name"
                                            :value="item2.id">
                                        </el-option>
                                    </el-select>
                               </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                                <el-col :span="8">
                                    <el-form-item label="Trámite"
                                                  prop="cat_category_id"
                                                  :rules="[{ required: true, message: 'El campo es requerido', trigger: 'change' }]">
                                    <el-select
                                        filterable
                                        disabled
                                        v-model="manageForm.cat_category_id"
                                        style="width: 100%"
                                        placeholder="Seleccionar">
                                        <el-option
                                            v-for="item2 in catalogsFilter(11)"
                                            :key="item2.id"
                                            :label="item2.name"
                                            :value="item2.id">
                                        </el-option>
                                    </el-select>
                               </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="Tipo de Trámite"
                                                  prop="cat_procedure_id"
                                                  :rules="[{ required: true, message: 'El campo es requerido', trigger: 'change' }]">
                                        <el-select
                                            filterable
                                            @change="refactorRequest()"
                                            v-model="manageForm.cat_procedure_id"
                                            style="width: 100%"
                                            placeholder="Seleccionar">
                                            <el-option
                                                v-for="item2 in catalogsFilter(5).filter(up => up.cat_category_id == manageForm.cat_category_id)"
                                                :key="item2.id"
                                                :label="item2.name"
                                                :value="item2.id">
                                            </el-option>
                                        </el-select>
                                   </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="Documentos"
                                                  prop="templates"
                                                  :rules="[{ required: false, message: 'El campo es requerido', trigger: 'change' }]">
                                        <el-select
                                            filterable
                                            multiple
                                            :multiple-limit="1"
                                            value-key="id"
                                            @change="isSignable(manageForm.templates)"
                                            v-model="manageForm.templates"
                                            style="width: 100%"
                                            placeholder="Seleccionar">
                                            <el-option
                                                v-for="(item2, key) in catalogsFilter(13).filter(up=> up.cat_procedure_id == manageForm.cat_procedure_id)"
                                                :key="item2.id"
                                                :disabled="(item2.first || item2.isHelp) && manageForm.cat_category_id != 3"
                                                :label="item2.name"
                                                :value="item2">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="Signatario"
                                              prop="signedBy"
                                              :rules="[{ required: true, message: 'El campo es requerido', trigger: 'change' }]">
                                        <el-select
                                            filterable
                                            clearable
                                            value-key="id"
                                            @change="mangeForm.password = null"
                                            v-model="manageForm.signedBy"
                                            style="width: 100%"
                                            placeholder="Seleccionar">
                                            <el-option
                                                v-for="(signatory, key) in catalogsFilter(80)"
                                                :key="signatory.id"
                                                :label="signatory.full_name"
                                                :value="signatory.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                            </el-col>
                        </el-row>
                        <br>

                        <el-row v-if="manageTemplates.templates && manageTemplates.templates.length > 0
                         && manageTemplates.templates[0].isSigned && userInfo.id == manageForm.signedBy  && manageForm.cat_cateogry_id != 1"
                                :gutter="20">
                            <el-alert
                                title="Uno de los documentos seleccionados, requiere firma electrónica. Ingrese su contraseña e.firma"
                                type="info"
                                show-icon>
                            </el-alert>
                            <el-col :span="10">
                                <el-form-item label="Contraseña e.firma"
                                              prop="password"
                                              :rules="[{ required: true, message: 'El campo es requerido', trigger: 'change' }]">
                                    <el-input v-my-only-alphanumeric="{maxChars: 70}" show-password
                                              v-model="manageForm.password"></el-input>
                               </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <br>
                <el-row :gutter="10" v-if="showEditor">
                    <el-col :span="24">
                        <el-collapse accordion v-model="activeName3">
                            <el-collapse-item :name="'Editar Documentos'">
                                <template slot="title">
                                    <el-button type="text" icon="el-icon-circle-plus-outline">
                                        Editor de Documentos {{manageTemplates.templates
                                        && manageTemplates.templates.length > 0 && manageTemplates.templates[0].name
                                        ?' '+ manageTemplates.templates[0].name : ''}}
                                    </el-button>
                                </template>
                                <ManageTemplates></ManageTemplates>
                            </el-collapse-item>
                        </el-collapse>
                    </el-col>
                </el-row>
                <span slot="footer" class="dialog-footer">
                        <el-button
                            type="danger"
                            plain
                            icon="fas fa-times"
                            @click="getMyRequests">
                            Cerrar
                        </el-button>
                    <el-button
                        type="primary"
                        plain
                        icon="fas fa-file-word"
                        @click="goToEdit">
                            Generar Documentos
                    </el-button>
                    <el-button
                        type="success"
                        plain
                        icon="fas fa-save"
                        @click="saveService">
                            Actualizar
                    </el-button>
                    <el-button
                        type="info"
                        plain
                        v-if="userInfo.isSignatory"
                        :loading="loading"
                        icon="fas fa-pen"
                        @click="updateRequest">
                            Dictaminar
                    </el-button>
                    <el-tooltip style="z-index: 9999 !important;" class="item" effect="dark"
                                content=" Se encontraron coincidencias" placement="top">
                         <el-button
                             style="margin-left: -258px; bottom: 60px"
                             type="info"
                             plain
                             v-if="searchableData && searchableData.length > 0"
                             :loading="loading"
                             icon="el-icon-info"
                             class="buttonFixed"
                             @click="searchableModal = true">
                             Coincidencias encontradas
                        </el-button>
                    </el-tooltip>

                </span>
            </el-dialog>
        </span>

        <el-dialog title="Coincidencias"
                   :visible.sync="searchableModal"
                   :close-on-press-escape="true"
                   :close-on-click-modal="false">
            <div class="modal-body" style="width:99.99%; height:400px; overflow: auto;">
                <el-card v-for="(item,key) in searchableData" v-if="item.data_form" :key="key">
                    <el-row :gutter="5"
                            :key="key"
                            style="border: 0.8px solid black; padding: 11px">
                        <el-col :span="8">
                            <label
                                class="el-form-item__label"
                                style="font-size: 8pt !important;">
                                Folio: {{item.folio}}
                            </label>
                        </el-col>
                        <el-col :span="8">
                            <label
                                class="el-form-item__label"
                                style="font-size: 8pt !important; word-break: break-word !important;">
                                Trámite: {{item.procedure.name}}
                            </label>
                        </el-col>
                        <el-col :span="8">
                            <el-button size="mini"
                                       type="primary"
                                       @click="changeData(item)">
                                Seleccionar
                            </el-button>
                        </el-col>
                    </el-row>
                    <el-row :gutter="5"
                            :key="key2"
                            v-for="(item2,key2) in item.data_form"
                            v-if="item2.data_info.form_field_type_id
                        && item2.data_info.isSearchable"
                            style="border: 0.8px solid black; padding: 11px">
                        <el-col :span="12">
                            <label
                                v-if="item2.data_info.form_field_type_id != 9"
                                class="el-form-item__label"
                                style="font-size: 8pt !important;">
                                {{item2.data_info.label}}:
                            </label>
                        </el-col>
                        <el-col :span="12">
                            <label
                                type="text"
                                class="el-form-item__label"
                                style="font-weight: bold !important; font-size: 8pt !important; text-align: center !important; word-break: break-word !important;">
                                {{filterData(item2)}}
                            </label>
                        </el-col>
                    </el-row>
                    <el-row v-for="(item2,key2) in item.data_form"
                            style="border: 0.8px solid black; padding: 8px; word-break: break-word !important;"
                            :key="key2"
                            v-if="(item2.data_info.id == 16
                        || item2.data_info.id == 76
                        || item2.data_info.id == 45
                        || item2.data_info.id == 61
                        || item2.data_info.id == 32
                        || item2.data_info.id == 89
                        || item2.data_info.id == 15
                        || item2.data_info.id == 44
                        || item2.data_info.id == 75
                        || item2.data_info.id == 60
                        || item2.data_info.id == 31
                        || item2.data_info.id == 88
                        || item2.data_info.id == 356
                        || item2.data_info.id == 357
                        || item2.data_info.id == 355
                        || item2.data_info.id == 354
                        || item2.data_info.id == 353
                        || item2.data_info.id == 352
                        || manageForm.cat_category_id == 2 && filterData(item2) != null)">
                        <el-col :span="12">
                            <label
                                v-if="item2.data_info.form_field_type_id != 9"
                                class="el-form-item__label"
                                style="font-size: 8pt !important; word-break: break-word !important;">
                                {{item2.data_info.label}}:
                            </label>
                        </el-col>
                        <el-col :span="12"
                                style="font-weight: bold !important; font-size: 8pt !important; text-align: center !important; word-break: break-word !important;">
                            {{filterData(item2)}}
                        </el-col>

                    </el-row>
                </el-card>
            </div>


        </el-dialog>


        <el-dialog title="Otras solicitudes"
                   :visible.sync="showModalUnify"
                   :close-on-press-escape="true"
                   :close-on-click-modal="false">
            <el-collapse accordion v-model="activeName2">
                <el-collapse-item v-for="(item,key) in unifyData" v-if="item.data_form" :key="key"
                                  :title="'No.'+(key+1)">
                    <template slot="title">
                        <a type="text" icon="el-icon-circle-plus-outline">
                            Folio: {{item.folio}}
                        </a>
                        <el-tooltip class="item" effect="dark" content="Ver Documentos">
                            <el-button type="primary" icon="far fa-eye"
                                       size="mini"
                                       plain @click="getDocs(item.id, item.folio)">
                            </el-button>
                        </el-tooltip>

                    </template>
                    <el-card>
                        <el-row :gutter="5"
                                :key="key2"
                                v-for="(item2,key2) in item.data_form"
                                v-if="item2.data_info.form_field_type_id != 9 && filterData(item2) != null"
                                style="border: 0.8px solid black; padding: 11px">
                            <el-col :span="12">
                                <label
                                    v-if="item2.data_info.form_field_type_id != 9"
                                    class="el-form-item__label"
                                    style="font-size: 8pt !important;">
                                    {{item2.data_info.label}}:
                                </label>
                            </el-col>
                            <el-col :span="12">
                                <label
                                    class="el-form-item__label"
                                    style="font-weight: bold !important; font-size: 8pt !important; text-align: center !important">
                                    {{filterData(item2)}}
                                </label>
                            </el-col>
                        </el-row>
                    </el-card>
                </el-collapse-item>
            </el-collapse>


        </el-dialog>

        <el-dialog title="Documentos" :visible.sync="showModalDocuments"
                   :close-on-press-escape="true"
                   :close-on-click-modal="false">
            <el-table :data="documents" size="small" style="width: 100%">
                <el-table-column
                    label="Nombre de archivo"
                    min-width="200px">
                    <template slot-scope="scope">
                        {{scope.row.fileName ? scope.row.fileName : ''}}
                        <span v-if="scope.row.file">
                              {{  scope.row.file.fileName}}
                         </span>
                    </template>
                </el-table-column>

                <el-table-column
                    label="Descripción"
                    min-width="200px">
                    <template slot-scope="scope">

                        <el-input v-model="scope.row.description"
                                  :maxlength="500"
                                  v-if="scope.row.id"
                                  placeholder="">
                        </el-input>
                        <el-input v-model="scope.row.description"
                                  :maxlength="500"
                                  v-if="!scope.row.id"

                                  placeholder="">
                        </el-input>

                    </template>
                </el-table-column>


                <el-table-column label="Opciones de edición" align="center" min-width="160">
                    <template slot-scope="scope">

                        <div>
                            <el-button-group>
                                <el-tooltip
                                    v-if="scope.row.id"
                                    class="item"
                                    effect="dark"
                                    content="Ver documento"
                                    placement="top-end">
                                    <el-button
                                        size="small"
                                        icon="el-icon-view"
                                        @click="showPdf(scope.row)">
                                    </el-button>
                                </el-tooltip>
                                <!-- <el-tooltip
                                     class="item"
                                     effect="dark"
                                     content="Eliminar documento"
                                     placement="top-end">
                                     <el-button
                                         size="small"
                                         type="danger"
                                         @click="removeDocument(scope.row)">
                                         <i class="fas fa-trash"></i>
                                     </el-button>
                                 </el-tooltip>-->
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    content="Eliminar documento"
                                    placement="top-end">
                                    <el-button
                                        :disabled="true"
                                        size="small"
                                        type="danger"
                                        @click="removeDocument(scope.row)">
                                        <i class="fas fa-trash"></i>
                                    </el-button>
                                </el-tooltip>
                            </el-button-group>
                        </div>
                    </template>

                </el-table-column>
            </el-table>
        </el-dialog>

        <el-dialog title="Documento"
                   :visible.sync="showDocumentAux"
                   :close-on-press-escape="true"
                   :close-on-click-modal="true">
            <el-row>
                <span v-if="!photoUrl"
                      slot="title" class="dialog__title" style="color: #fff;">
                    <p style="color:white">
                        Cargando documento, por favor espere...
                    </p>
                    <br>
                    <div v-loading="!photoUrl"></div>
                </span>
                <span v-if="photoUrl" slot="title" class="dialog__title" style="color: #fff;">
                    <el-row>
                        <el-col>
                            Documento
                            <div style="position: absolute;bottom: -2px;right: 104px;">
                            <el-button type="info" plain @click="downloadPdf">
                                <i class="fas fa-cloud-download-alt"></i>&nbsp;Descargar
                            </el-button>
                            </div>
                        </el-col>
                    </el-row>
                </span>
                <div v-if="photoUrl" style="background: #494a4cd1">
                    <el-row>
                        <el-col>
                            <div style="width: 100%;height: 100vh;margin-left: auto;margin-right: auto">
                                <object v-if="photoUrl"
                                        :data="photoUrl"
                                        width="100%" height="100%">
                                    <p>
                                        Su navegador no soporta la vista de preview en línea, por favor descargue el
                                        archivo
                                        para visualizar.
                                    </p>
                                </object>
                            </div>

                        </el-col>
                    </el-row>
                </div>
            </el-row>
        </el-dialog>


    </div>
</template>

<script>
    import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
    import HeaderSection from '@/components/partials/HeaderSection';
    import draggable from 'vuedraggable';
    import VueContentLoading from "vue-content-loading";
    import {Notification} from 'element-ui';
    import Filters from "./partials/Filters";
    import PaymentValidation from "../administration/settings/templates/partials/PaymentValidation";
    import {wordMix} from '@/mixins/word';

    const ManageTemplates = _ => import(
        /* webpackChunkName: "js/split/ManageTemplates", webpackPreload: true */ '@/components/views/registers/partials/ManageTemplates'
        );

    export default {
        components: {
            HeaderSection,
            draggable,
            VueContentLoading,
            Filters,
            PaymentValidation,
            ManageTemplates
        },
        mixins: [wordMix],

        computed: {
            ...mapGetters('requests', {
                inboxForm: "inboxForm",
                filters: "filters",
            }),
            userInfo() {
                return this.$store.state.user.user;
            },

            ...mapGetters('utils', {
                makeProcedure: "makeProcedure",
                requestForm: "requestForm",
            }),

            ...mapGetters('templates', {
                templateForm: "templateForm",
            }),
            alias_this() {
                return this;
            },

            dragOptions() {
                return {
                    animation: 200,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            },

        },

        created() {
            let _templates = {
                form: null,
                sipac_request_id: null,
                cat_procedure_id: null,
                templates: null,
                html: null,
                isGenerate: null
            };
            this.addTemplates(_templates);
            this.notRequets = false;
            this.loading = true;
            this.dataShow = true;
            this.inboxForm.inbox = [];
            this.filters.arrayFilters = [];
            this.manageTemplates.templates = [];
            this.manageTemplates.isGenerate = false;
            this.manageTemplates.html = null;
            axios.get('/api/catalogs-forms', {params: {all: true}}).then(response => {
                if (response.data.success) {
                    this.catalogs = response.data.catalogs;
                    this.showFilters = true;
                }
                this.dataShow = false;
                this.loading = false;
            })
        },

        watch: {
            'signValid'(value) {
                if (value) {
                    this.signValid = true;
                }
            }
        },

        data() {
            return {
                showDocumentAux: false,
                photoUrl: null,
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    }
                },
                inbox: {
                    cat_category_id: null,
                    cat_procedure_id: [],
                },
                catalogs: {
                    categories: [],
                    procedures: []
                },
                showModalDocuments: false,
                loading: false,
                dataShow: false,
                drag: false,
                activeName: null,
                activeName3: null,
                currentPage: 1,
                perPage: 5,
                total: 0,
                showLogs: false,
                notRequets: false,
                customFolio: '',
                logs: [],
                sipac_request_id: null,
                manageModal: false,
                manageForm: {templates: [], password: ''},
                showFilters: false,
                signValid: false,
                signForm: {},
                modalSign: false,
                loadingExcel: false,
                showPassword: false,
                searchableData: [],
                searchableModal: false,
                showModalUnify: false,
                unifyData: null,
                activeName2: null,
                customKey: null,
                cloneStatus: null,
                isManageForm: false,
                documents: [],
                showEditor: false,
                sowModalLog: false,
                auxLogs: [],
                aliasForm: [],
                filtersForm: {
                    folio: null,
                    cat_status_id: null,
                    dates: null,
                    name: null,
                    firstName: null,
                    secondName: null,
                    trustees: null,
                    moralPerson: null,
                    record: null,
                    permission: null
                }
            }
        },

        methods: {
            ...mapActions('utils', [
                'addProcedureData'
            ]),
            ...mapActions('requests', [
                'addTemplates'
            ]),
            /* ...mapActions('templates', [
                 'addMangeTemplate'
             ]),*/

            goToBack() {
                this.$router.push('/')
            },

            saveService() {

                this.$confirm('¿Desea que la solicitud pase a estatus Por Autorizar?', 'Alerta', {
                    confirmButtonText: 'Por Autorizar',
                    cancelButtonText: 'Solo Actualizar',
                    type: 'warning',

                }).then((valid) => {

                    let _docs = this.manageTemplates.isGenerate;
                    let _payment = this.inboxForm.inbox.filter(up => up.id == this.manageForm.id);
                    _payment = _.head(_payment);
                    _payment = _payment.payment;
                    if (this.manageForm.cat_category_id == 2
                        && _payment
                        && this.manageForm.cat_status_id == 19) {
                        this.$store.dispatch('notifications/warning', {msg: 'No se ha validado el pago o no se han generado documentos para dictamen. Por favor guarde o descargue un documento.'}, {root: true});
                        return false
                    }
                    if (this.manageTemplates.isGenerate == false) {

                        this.$store.dispatch('notifications/warning', {msg: 'No se ha validado el pago o no se han generado documentos para dictamen.'}, {root: true});
                        return false
                    }
                    this.manageForm.cat_status_id = 3;
                    let _params = {
                        ...this.manageForm,
                        template: null

                    };
                    axios.post('/api/manage-request', _params)
                        .then(response => {
                            if (response.data.success && response.data.update) {
                                this.$store.dispatch('notifications/ok', {msg: response.data.message}, {root: true});
                                this.loading = false;
                                this.manageModal = false;
                                this.getMyRequests()
                            } else {
                                this.$store.dispatch('notifications/error', {msg: 'No se pudo procesar su solicitud.'}, {root: true});
                                this.loading = false;
                            }
                        })
                        .catch(error => {
                            console.log('saveService', error);
                            this.$store.dispatch('notifications/error', {msg: 'No se pudo procesar su solicitud o no se valiaron las credenciales de su e.firma. Trate nuevamente.'}, {root: true});
                            this.loading = false;
                        });

                }).catch((e) => {
                    this.$confirm('Actualizando...', '¡Atención!', {
                        confirmButtonText: 'Actualizar',
                        cancelButtonText: 'Cancelar',
                        type: 'info'
                    }).then(() => {
                        let _params = {
                            ...this.manageForm,
                            template: null

                        };
                        axios.post('/api/manage-request', _params)
                            .then(response => {
                                if (response.data.success && response.data.update) {
                                    this.$store.dispatch('notifications/ok', {msg: response.data.message}, {root: true});
                                    this.loading = false;
                                    this.manageModal = false;
                                    this.getMyRequests()
                                } else {
                                    this.$store.dispatch('notifications/error', {msg: 'No se pudo procesar su solicitud.'}, {root: true});
                                    this.loading = false;
                                }
                            })
                            .catch(error => {
                                console.log('saveService', error);
                                this.$store.dispatch('notifications/error', {msg: 'No se pudo procesar su solicitud o no se valiaron las credenciales de su e.firma. Trate nuevamente.'}, {root: true});
                                this.loading = false;
                            });

                    }).catch(e => {
                        this.$store.dispatch('notifications/info', {msg: 'No se realizó ningún cambio.'}, {root: true});
                    })

                });


            },

            customDisabled(id) {
                if (id == 320 || id == 293 || id == 395 || id == 93 || id == 266 || id == 123 || id == 223
                    || id == 249 || id == 188 || id == 184 || id == 179 || id == 192 || id == 174) {
                    return true
                } else {
                    return false
                }
            },

            downloadPdf() {
                let url = null;
                if (this.fileNameHash) {
                    url = '/api/showFile/' + this.fileNameHash;
                }
                if (this.urlPdfGenerate) {
                    url = this.urlPdfGenerate;
                }

                this.showLoading('Descargando documento...');

                axios.get(url, {responseType: 'blob'})
                    .then(response => {
                        this.transfer = false;
                        let disposition = response.headers['content-disposition'];
                        var filename = '';
                        if (disposition && disposition.indexOf('inline') !== -1) {
                            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                            var matches = filenameRegex.exec(disposition);
                            if (matches != null && matches[1]) {
                                filename = matches[1].replace(/['"]/g, '');
                            }
                        }


                        let blob = new Blob([response.data]);
                        const linkUrl = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = linkUrl;

                        link.setAttribute('download', filename);
                        document.body.appendChild(link);
                        link.click();
                        this.hideLoading();
                    })
                    .catch(error => {


                        this.hideLoading();
                        this.transfer = false;
                    });

            },

            goToUnify() {
                this.$store.dispatch('notifications/warning', {msg: 'Por favor... Mantenga abierta esta pestaña, será redireccionado al módulo correspondiente.'}, {root: true});

                setTimeout(() => {
                    let url = `/inbox/unify`;
                    window.open(url, '_blank');
                }, 2000)
            },

            showPdf(data) {
                let _id = null;

                if (data && data.file && data.file.fileNameHash) {
                    _id = data.file.fileNameHash
                } else {
                    _id = data.fileNameHash
                }
                let _self = this;
                let url = '/api/showFile/' + _id;
                axios.get(url, {responseType: 'blob'})
                    .then(response => {
                        let blob = new Blob([response.data], {type: response.data.type});
                        this.photoUrl = URL.createObjectURL(blob);
                        _self.showDocumentAux = true
                    })
                    .catch(error => {

                        this.$store.dispatch('notifications/error', {msg: 'No se puede visualizar'}, {root: true});

                        console.log("error", error);
                    });


            },

            makeRegister() {
                if (this.inbox.cat_procedure_id.length == 0) {
                    this.$notify({
                        type: 'warning',
                        title: '¡Atención!',
                        message: 'Seleccione al menos un trámite para generar solicitudes'
                    })
                    return false
                }

                this.$confirm('Se generará una solicitud por cada trámite seleccionado',
                    {
                        confirmButtonText: 'Continuar',
                        title: '¡Atención!',
                        showClose: false,
                        closeOnPressEscape: false,
                        closeOnClickModal: false,
                        type: 'warning',
                        center: true
                    }).then(confirm => {
                    let _params = {
                        ...this.inbox
                    };

                    axios.post('/api/admin-requests', _params).then(response => {
                        if (response.data.success) {
                            this.getMyRequests();
                        } else {
                            this.$store.dispatch('notifications/error', {msg: response.data.message}, {root: true});
                        }
                    }).catch(_ => {
                        this.$store.dispatch('notifications/error', {msg: 'No se pudo completar la solicitud'}, {root: true});
                    });
                }).catch(e => {
                    this.$store.dispatch('notifications/warning', {msg: 'No se registró ningun cambio.'}, {root: true});
                });
            },

            getMyRequests() {
                if (this.inbox.cat_procedure_id.length > 0) {
                    this.manageTemplates.html = null;
                    this.manageTemplates.isGenerate = false;
                    this.searchableData = [];
                    this.manageModal = false;
                    let _filters = {
                        folio: this.filtersForm.folio,
                        dates: this.filtersForm.dates,
                        cat_status_id: this.filtersForm.cat_status_id,
                        cat_procedure_id: this.inbox.cat_procedure_id,
                        name: this.filtersForm.name,
                        firstName: this.filtersForm.firstName,
                        secondName: this.filtersForm.secondName,
                        trustees: this.filtersForm.trustees,
                        moralPerson: this.filtersForm.moralPerson,
                        record: this.filtersForm.record,
                        permission: this.filtersForm.permission,
                    };

                    let params = {
                        ...this.inbox,
                        page: this.currentPage,
                        perPage: this.perPage,
                        filters: _filters
                    };
                    this.dataShow = true;
                    this.loading = true;
                    axios.get('/api/get-my-requests', {params}).then(response => {
                        if (response.data.success) {
                           /* this.filtersForm.folio = null;
                            this.filtersForm.cat_status_id = null;
                            this.filtersForm.dates = null;
                            this.filtersForm.name = null;
                            this.filtersForm.firstName = null;
                            this.filtersForm.secondName = null;
                            this.filtersForm.trustees = null;
                            this.filtersForm.moralPerso = null;*/
                            this.inboxForm.inbox = response.data.inbox.data;

                            let _templates2 = {
                                form: null,
                                sipac_request_id: null,
                                cat_procedure_id: null,
                                templates: [],
                                html: null,
                            };
                            this.addTemplates(_templates2);

                            if (this.inboxForm.inbox.length == 0) {
                                this.notRequets = true;
                            } else {
                                _.forEach(this.inboxForm.inbox, (item, key) => {
                                    if (item.data_form && item.data_form.length > 0) {
                                        _.orderBy(response.data.catalogs, ['name'], ['asc']);
                                        item.data_form = _.uniqBy(item.data_form, 'form_field_id');
                                        item.data_form = _.orderBy(item.data_form, ['data_info.order'], ['asc']);
                                    }
                                });
                            }
                            this.total = response.data.inbox.total;
                            this.current_page = response.data.inbox.current_page;
                        } else {
                            this.$store.dispatch('notifications/error', {msg: response.data.message}, {root: true});
                        }
                        this.dataShow = false;
                        this.loading = false;
                    }).catch(error => {
                        console.log('getMyRequests', error);
                        this.loading = false;
                        this.$notify({
                            type: 'error',
                            title: 'Error',
                            message: 'No fue posible cargar plantilla'
                        });
                    });
                }
            },

            getRequestDocs(data) {
                this.documents = data.documents;

                this.showModalDocuments = true;
            },

            filterData(item) {
                let _name = null;
                if (item && item.data_info.form_field_type_id == 1 || item.data_info.form_field_type_id == 2) {
                    _name = item.textData;
                } else if (item && item.data_info.form_field_type_id == 4) {
                    _name = item.booleanData;
                } else if (item && item.data_info.form_field_type_id == 5) {
                    let _options = [];
                    let _system_catalog_id = item.data_info.system_catalog_id;
                    let _system_option_id = item.option_system_catalog_id;

                    let _name_catalog = this.catalogs.filter(up => up.id == _system_catalog_id);
                    _options = _.head(_name_catalog).options;
                    _name = _options.filter(up => up.id == _system_option_id);
                    _name = _.head(_name);
                    _name = _name && _name.name ? _name.name : 'Sin información';


                } else if (item && item.data_info.form_field_type_id == 4) {
                    _name = item.booleanData;
                } else if (item && item.data_info.form_field_type_id == 10) {
                    _name = item.dataNumber;
                } else if (item && item.data_info.form_field_type_id == 6) {
                    _name = item.dateData;
                }
                return _name;
            },

            filterOptions(item, key, options) {
                let _customOptions = options;
                if (!item) return [];
                if (item.system_catalog_id == 9) {
                    let _cat_state_id = null;
                    _cat_state_id = this.requestForm.form.filter(up => up.system_catalog_id == 8);
                    _cat_state_id = _.head(_cat_state_id);
                    _cat_state_id = _cat_state_id.data;

                    let _municipalities = options

                    if (_municipalities.length > 0) {
                        _municipalities = _municipalities.filter(up => up.cat_state_id == _cat_state_id)
                        _customOptions = _municipalities;
                    }


                } else {
                    _customOptions = item.options
                }
                return _customOptions
            },

            catalogsFilter(id, options) {
                let _options = [];
                if (id != 9) {
                    _.forEach(this.catalogs, (item, key) => {
                        if (item && item.id == id) {
                            _options = item.options;
                        }
                        if (item && item.id == options) {
                            _options = item.options;
                        }
                    });
                    return _options
                } else if (id == 9 || options == 9) {
                    let _cat_state_id = null;
                    _cat_state_id = this.manageForm.data_form.filter(up => up.system_catalog_id == 8);
                    if (_cat_state_id && _cat_state_id.length > 0 && _cat_state_id[0].option_system_catalog_id) {
                        let aux = this.catalogs.filter(up => up.id == 9);
                        aux = _.head(aux)
                        return _options = aux.options.filter(up => up.cat_state_id == _cat_state_id[0].option_system_catalog_id)
                    }

                }

            },


            isSignable(array) {
                this.showPassword = false
                if (array && array.length > 0) {
                    _.forEach(array, (item, key) => {
                        if (item.isSigned) {
                            this.showPassword = true
                        }
                    })
                }

            },


            handleCurrentChange(page) {
                this.currentPage = page;
                this.getMyRequests(this.inbox.cat_procedure_id);
            },

            handleSizeChange(value) {
                this.perPage = value;
                this.getMyRequests(this.inbox.cat_procedure_id);
            },

            getDocs(id, folio, documents) {
                if (id) {
                    let params = {
                        ...this.inbox,
                        perPage: this.perPage,
                        sipac_request_id: id,
                    };
                    this.loading = true;
                    this.sipac_request_id = id;
                    axios.get('/api/get-prints-log', {params}).then(response => {
                        if (response.data.success) {
                            this.showLogs = true;
                            this.logs = response.data.logs;
                            this.customFolio = folio
                        } else {
                            this.$store.dispatch('notifications/info', {msg: response.data.message}, {root: true});
                        }
                        this.loading = false;
                    }).catch(error => {
                        console.log('getDocs', error);
                        this.loading = false;
                        this.$notify({
                            type: 'error',
                            message: 'No se pudo completar la acción'
                        });
                    });
                }
            },
            showLoading(message) {
                this.$store.dispatch(
                    'loading/spinner',
                    {msg: message, status: true},
                    {root: true}
                );
            },
            hideLoading() {
                this.$store.dispatch('loading/spinner', {}, {root: true});
            },
            showDocument(html, id, count, file) {
                if (html) {
                    let _params = {
                        templateHtml: html,
                        cat_config_template_section_id: id,
                        count: count,
                        sipac_request_id: this.sipac_request_id,
                        sipac_file_id: file
                    };
                    this.showLoading('Descargando documento...');
                    axios.post('/api/show-log-document', _params, {responseType: 'blob'})
                        .then(response => {
                            this.$store.dispatch('notifications/ok', {msg: 'Descargando documento...'}, {root: true});
                            const linkUrl = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = linkUrl;
                            link.setAttribute('download', `SIPAC-${moment(new Date()).format('DD-MM-YYYY-HH:MM:SS')}.pdf`);
                            document.body.appendChild(link);
                            link.click();
                            this.hideLoading();

                        })
                        .catch(error => {
                            this.hideLoading();
                            this.$store.dispatch('notifications/error', {msg: 'No fue posible generar su documento'}, {root: true});

                        });
                }
            },
            deleteDocument(id) {
                if (id) {
                    let _params = {
                        id: id
                    };
                    this.showLoading('Eliminando documento...');
                    axios.post('/api/delete-document', _params).then(response => {
                        if (response.data.success) {
                            this.hideLoading();
                            this.showLogs = false;
                            this.getMyRequests();
                            this.$store.dispatch('notifications/ok', {msg: response.data.message}, {root: true});
                        } else {
                            this.hideLoading();
                            this.showLogs = false;
                            this.$store.dispatch('notifications/error', {msg: response.data.message}, {root: true});
                        }

                    }).catch(error => {
                        this.hideLoading();
                        this.showLogs = false;
                        this.$store.dispatch('notifications/error', {msg: 'Error al procesar su solicitud'}, {root: true});
                    });
                }
            },

            manageRequest(item, key) {

                if (item) {
                    let _updateDocs = this.catalogsFilter(13);
                    _.forEach(_updateDocs, item => {
                        item.html = null
                    });
                    this.aliasForm = [];
                    this.manageForm = Object.assign({}, item);
                    let _templates2 = {
                        form: null,
                        sipac_request_id: null,
                        cat_procedure_id: null,
                        templates: [],
                        html: null,
                    };
                    this.addTemplates(_templates2);
                    let _logs = this.manageForm.logs && this.manageForm.logs.length > 0 ? this.manageForm.logs.filter(up => !up.isSigned) : [];
                    if (_logs && _logs.length > 0) {
                        let _array = [];
                        let _logId = _logs[0].id;
                        let _html = _logs[0].html;
                        let _isSigned = Object.assign([], this.catalogsFilter(13).filter(up => up.cat_procedure_id == this.manageForm.cat_procedure_id));
                        _isSigned = _isSigned.filter(up => up.id == _logs[0].template_config.config.template.id);
                        _isSigned = _.head(_isSigned);
                        _isSigned = _isSigned.isSigned ? true : false;

                        _logs = _logs[0].template_config.config.template;
                        _logs.logId = _logId;
                        _logs.isSigned = _isSigned;
                        _logs.html = _html;
                        _array.push(_logs);
                        let _templates2 = {
                            form: this.manageForm.data_form,
                            sipac_request_id: this.manageForm.id,
                            cat_procedure_id: this.manageForm.cat_procedure_id,
                            templates: _array,
                            html: _logs.html,
                        };
                        this.addTemplates(_templates2);
                        this.loading = false;
                        this.showEditor = true;
                        this.customKey = key;
                        this.manageModal = true;
                    } else {
                        let _templates = {
                            html: null,
                            isGenerate: false
                        };
                        this.addTemplates(_templates);
                        this.aliasForm = [];
                        this.customKey = key;
                        this.manageForm = Object.assign({}, item);
                        this.manageModal = true;
                        this.showEditor = false;
                    }

                }
            },

            updateRequest() {

                if (this.manageTemplates.templates.length > 0 && this.manageTemplates.templates[0].isSigned && this.manageForm.password == null
                    || this.manageForm.password == '') {
                    this.$store.dispatch('notifications/warning', {msg: 'No está autorizado para realizar esta acción.'}, {root: true});
                    return false;
                }

                if (!this.userInfo.isSignatory) {
                    this.$store.dispatch('notifications/warning', {msg: 'Usted no está autorizado para dictamniar.'}, {root: true});
                    return false;
                }
                if (this.manageTemplates.isGenerate == false) {
                    this.$store.dispatch('notifications/warning', {msg: 'No hay documentos para dictaminar, descargue o guarde un documento...'}, {root: true});
                    return false;
                }
                let _payment = this.inboxForm.inbox.filter(up => up.id == this.manageForm.id);
                _payment = _.head(_payment);
                _payment = _payment.payment;
                if (this.manageForm.cat_category_id == 2
                    && _payment
                    && this.manageForm.cat_status_id == 19) {
                    this.$store.dispatch('notifications/warning', {msg: 'No se ha validado el pago o no se han generado documentos para dictamen.'}, {root: true});
                    return false
                }
                if (this.manageForm.cat_status_id == 3 || this.manageForm.cat_status_id == 2) {
                    this.$refs['manageForm'].validate(valid => {
                        if (valid) {
                            this.loading = true;
                            this.modalSign = false;
                            let _responseType = 'blob';
                            if (this.manageTemplates.templates && this.manageTemplates.templates.length > 0) {
                                _.forEach(this.manageTemplates.templates, (item, key) => {
                                    item.html = this.manageTemplates.html;
                                    let _params = {
                                        ...this.manageForm,
                                        template: item,
                                    };
                                    axios.post('/api/manage-request', _params, {responseType: 'blob'})
                                        .then(response => {
                                            let _type = response.data.type.toString();
                                            if (_type == 'application/pdf') {
                                                const linkUrl = window.URL.createObjectURL(new Blob([response.data]));
                                                const link = document.createElement('a');
                                                link.href = linkUrl;
                                                this.$store.dispatch('notifications/ok', {msg: 'Solicitud actualizada correctamente. Descargando documentos...'}, {root: true});
                                                this.loading = false;
                                                let _name = this.manageTemplates.templates
                                                && this.manageTemplates.templates.length > 0 && this.manageTemplates.templates[0].name
                                                    ? ' ' + this.manageTemplates.templates[0].name : ''
                                                link.setAttribute('download', `SIPAC27-${_name + ' ' + this.manageForm.folio}.pdf`);
                                                document.body.appendChild(link);
                                                link.click();
                                                Notification.closeAll();
                                                this.manageModal = false;

                                                this.getMyRequests();
                                            } else if (_type == 'application/json') {
                                                if (response.data && response.data.status && response.data.status != 200) {
                                                    this.$store.dispatch('notifications/error', {msg: 'No se pudo procesar su solicitud o no cuenta con autorización para firmar este documento.'}, {root: true});
                                                    this.loading = false;
                                                    this.manageModal = false;
                                                } else {
                                                    this.$store.dispatch('notifications/error', {msg: 'No se pudo procesar su solicitud o no cuenta con autorización para firmar este documento'}, {root: true});
                                                    this.loading = false;
                                                }
                                            }
                                        })
                                        .catch(error => {
                                            console.log('updateRequest', error);
                                            this.$store.dispatch('notifications/error', {msg: 'No se pudo procesar su solicitud o no se valiaron las credenciales de su e.firma. Trate nuevamente.'}, {root: true});
                                            this.loading = false;
                                        });
                                })
                            }

                        } else {
                            this.$store.dispatch('notifications/warning', {msg: 'Complete los campos requeridos'}, {root: true});
                            this.loading = false;
                        }
                    })

                }

            },

            reportExcel() {
                if (this.inboxForm.inbox && this.inboxForm.inbox.length > 0) {
                    let params = {
                        requests: this.inboxForm.inbox.map(up => up.id),
                        procedures: this.inboxForm.inbox.map(up => up.cat_procedure_id)
                    };
                    this.loadingExcel = true;
                    axios.post('/api/report-excel', params, {responseType: 'blob'}).then(response => {
                        let now = new Date().toLocaleDateString();
                        const linkUrl = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = linkUrl;
                        link.setAttribute('download', `Reporte-SIPAC-${moment(new Date()).format('DD-MM-YYYY-HH:MM:SS')}.xlsx`);
                        document.body.appendChild(link);
                        link.click();
                        this.loadingExcel = false;
                        this.$notify({
                            title: 'Éxito',
                            message: 'Fue generado el reporte en excel',
                            type: 'success'
                        });
                    })
                        .catch(error => {
                            this.$notify({
                                title: 'Error',
                                message: 'No fue posible realizar la descarga, inténtelo nuevamente.',
                                type: 'warning'
                            });
                        });
                }
            },

            checkIsSearchable(item) {
                if (item && item.data_info && item.data_info.isSearchable && item.textData.length > 3) {
                    this.$confirm('¿Desea comenzar una búsqueda?', 'Búsquedas', {
                        confirmButtonText: 'Sí',
                        cancelButtonText: 'Seguir capturando.',
                        type: 'warning'
                    }).then(() => {
                        let _customArray = {
                            textData: item.textData,
                            form_field_id: item.form_field_id
                        };
                        this.aliasForm.push(_customArray);
                        _.forEach(this.aliasForm, (element, key) => {
                            if (item.form_field_id == element.form_field_id) {
                                this.aliasForm[key].textData = item.textData
                            }
                        });
                        this.aliasForm = _.uniqBy(this.aliasForm, 'form_field_id');
                        let filters = {
                            fields: this.aliasForm,
                            cat_category_id: this.manageForm.cat_category_id,
                            cat_procedure_id: this.manageForm.cat_procedure_id,
                            permission: false
                        };
                        this.showLoading('Iniciando búsqueda, espere...');
                        axios.post('/api/get-searchable', {filters}).then(response => {
                            if (response.data.success) {
                                this.searchableData = response.data.searchable;
                                if (this.searchableData.length > 0) {
                                    this.hideLoading();
                                    this.$store.dispatch('notifications/ok', {msg: 'Se encontraron coincidencias.'}, {root: true});
                                } else {
                                    this.hideLoading();
                                    this.$store.dispatch('notifications/info', {msg: 'No se encontraron coincidencias.'}, {root: true});
                                }

                            } else {
                                this.hideLoading();
                                this.$store.dispatch('notifications/warning', {msg: 'No se pudo completar la búsqueda, trate nuevamente.'}, {root: true});
                            }
                        }).catch(e => {
                            this.hideLoading();
                            this.$store.dispatch('notifications/error', {msg: 'Error inesperado...'}, {root: true});
                        })

                    }).catch(() => {
                        let _customArray = {
                            textData: item.textData,
                            form_field_id: item.form_field_id
                        }
                        this.aliasForm.push(_customArray);
                        this.$message({
                            type: 'info',
                            message: 'Búsqueda pospuesta.'
                        });
                    });


                }
            },

            changeData(data) {
                if (confirm("La información será reemplazada, ¿desea continuar?")) {
                    let _customData = data.data_form;

                    if (this.manageForm.cat_category_id != 2) {
                        _.forEach(this.manageForm.data_form, (item, key) => {
                            _.forEach(_customData, (item2, key2) => {
                                if (item.form_field_id == item2.form_field_id && (item2.data_info.form_field_type_id == 1 || item2.data_info.form_field_type_id == 2)) {
                                    this.manageForm.data_form[key].textData = item2.textData;
                                } else if (item.form_field_id == item2.form_field_id && item2.data_info.form_field_type_id == 5) {
                                    this.manageForm.data_form[key].option_system_catalog_id = item2.option_system_catalog_id;
                                }
                            })
                        });
                        setTimeout(() => {
                            this.searchableData = null;
                            this.searchableModal = false;
                        }, 500)
                    } else {
                        let _oldPermission = '';
                        _.forEach(this.manageForm.data_form, (item, key) => {
                            _.forEach(_customData, (item2, key2) => {
                                if (item.data_info.label == item2.data_info.label
                                    && (item2.data_info.form_field_type_id == 1
                                        || item2.data_info.form_field_type_id == 2)) {
                                    this.manageForm.data_form[key].textData = item2.textData;
                                    if (item.data_info.label == 'No. permiso'
                                        || item.data_info.label == 'No. Permiso'
                                        || item.data_info.label == 'No. de ermiso'
                                        || item.data_info.label == 'No. de Permiso') {
                                        this.manageForm.data_form[key].textData = null;
                                        _oldPermission = item2.textData;
                                    }
                                    if (item2.data_info.label == 'Permiso Anterior') {
                                        this.manageForm.data_form[key].textData = _oldPermission;
                                    }

                                } else if (item.data_info.label == item2.data_info.label && item2.data_info.form_field_type_id == 5) {
                                    this.manageForm.data_form[key].option_system_catalog_id = item2.option_system_catalog_id;
                                }
                            })
                        });
                        setTimeout(() => {
                            this.searchableData = null;
                            this.searchableModal = false;
                        }, 500)
                    }


                } else {

                }

            },


            showUnify(unify) {
                if (unify && unify.length > 0) {
                    let _params = {
                        unify: unify
                    };
                    axios.post('/api/show-unify', _params).then(response => {
                        if (response.data.success) {
                            this.showModalUnify = true;
                            this.unifyData = response.data.unify

                        }
                    })
                }

            },

            goToEdit() {
                let _isPaper = false;
                let _docs = this.manageForm.templates;
                let _templates2 = {
                    html: null,
                    isGenerate: false
                };
                this.addTemplates(_templates2);

                if (_docs && _docs.length == 0) {
                    this.$store.dispatch('notifications/warning', {msg: 'No se han seleccionado documentos.'}, {root: true});
                    return false
                }

                if (_docs && _docs.length > 0) {
                    this.isManageForm = true;
                    this.showEditor = false;
                    this.cloneStatus = this.manageForm.cat_status_id;
                    let _params = {
                        ...this.manageForm,
                        template: null,
                    };
                    this.$refs['manageForm'].validate(valid => {
                        if (valid) {
                            axios.post('/api/manage-request', _params)
                                .then(response => {
                                    this.loading = true;
                                    if (response.data.success && response.data.update) {
                                        this.$store.dispatch('notifications/warning', {msg: 'Espere mientras se genera su documento...'}, {root: true});
                                        let _templates2 = {
                                            form: this.manageForm.data_form,
                                            sipac_request_id: this.manageForm.id,
                                            cat_procedure_id: this.manageForm.cat_procedure_id,
                                            templates: _docs,
                                            isPaper: _isPaper,
                                            html: null,
                                            isGenerate: false
                                        };
                                        this.addTemplates(_templates2);
                                        this.loading = false;
                                        this.showEditor = true;
                                    }
                                })
                                .catch(error => {
                                    console.log('updateRequest', error);
                                    this.$store.dispatch('notifications/error', {msg: 'Error al generar ducumentación, trate nuevamente o seleccione otro docuemento.'}, {root: true});
                                    this.loading = false;
                                });
                        } else {
                            this.$store.dispatch('notifications/warning', {msg: 'Complete los campos requeridos antes de generar un documento.'}, {root: true});
                        }
                    })
                } else {
                    this.$store.dispatch('notifications/warning', {msg: 'Seleccione al menos un documento o un oficio para edición.'}, {root: true});
                }
            },

            setDocument() {
                let _papers = this.manageForm.data_form.filter(up => up.system_catalog_id == 20 || up.system_catalog_id == 21);
                this.manageForm.templates = [];
                if (_papers && _papers.length > 0 && _papers[0].option_system_catalog_id) {
                    let _allDocs = this.catalogsFilter(13).filter(up => up.cat_procedure_id == this.manageForm.cat_procedure_id);
                    let _type = this.manageForm.cat_category_id;
                    _type == 1 ?
                        _allDocs = _allDocs.filter(up => up.cat_trade_id == _papers[0].option_system_catalog_id) :
                        _allDocs = _allDocs.filter(up => up.cat_trade_trust_id == _papers[0].option_system_catalog_id);
                    _allDocs = _.head(_allDocs);
                    this.manageForm.templates.push(_allDocs);
                }


            },

            refactorRequest() {
                var _filter = this.manageForm && this.manageForm.logs.length > 0 ? this.manageForm.logs.filter(up => up.isSigned) : [];
                var _status = Object.assign({}, this.manageForm);
                if (_filter && _filter.length == 0) {
                    this.$confirm('Al realizar esta acción, los campos cambiarán y deberán de capturarse nuevamente. ¿Desea continuar?', 'Alerta', {
                        confirmButtonText: 'Continuar',
                        cancelButtonText: 'Cancelar',
                        type: 'warning'
                    }).then(() => {
                        let _params = {
                            ...this.manageForm
                        };
                        this.showLoading('Actualizando solicitud...');
                        axios.post('/api/refactor-request', _params).then(response => {
                            if (response.data.success) {

                                this.hideLoading();
                                this.getMyRequests();
                                this.manageModal = false;
                                this.$message({
                                    type: 'success',
                                    message: response.data.message
                                });


                            } else {
                                this.hideLoading();
                                this.$message({
                                    type: 'warning',
                                    message: 'No se pudo actualizar información. Trate nuevamente'
                                });

                            }
                        }).catch(e => {
                            this.hideLoading();
                            this.$message({
                                type: 'error',
                                message: 'Error al procesar información.'
                            });
                        })

                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: 'Cancelado'
                        });
                    });
                } else {
                    this.$message({
                        type: 'error',
                        message: 'Esta solicitud ya tiene documentos firmados. No puede cambiar el tipo de trámite.'
                    });
                    this.manageModal = false;
                }

            }


        }
    }
</script>

<style>
    .buttonFixed {

        outline: none;
        position: fixed;
        /*z-index: 99;*/
        bottom: 1em;
        font-size: 15px;
        padding: 10px 15px 10px 15px;
        border-radius: 45px;
        background-color: #0C231E;
        background-image: radial-gradient(circle farthest-corner at 100% 0, #13322B, transparent);
        border: 1px solid #dcdfe6;
        color: #fff;
    }

    .buttonFixed:hover {
        cursor: pointer;
        background-color: #3d9671;
        background-image: radial-gradient(circle farthest-corner at 100% 0, #13322B, transparent);
    }

    .buttonFixed:active,
    .buttonFixed:visited,
    .buttonFixed:link {
        background-color: #0C231E;
        background-image: radial-gradient(circle farthest-corner at 100% 0, #13322B, transparent);
    }

    .customCount > .el-input__count > input {
        background: none;
        font-size: 8px;
    }

</style>
